import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { InvoiceItem } from './invoice-item.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class InvoiceItemService extends AbstractEntityService {

    protected resourceUrl = 'api/invoice-items';
    private resourceSearchUrl = 'api/_search/invoice-items';
    protected resourceCountUrl = 'api/_search/count/invoice-items';

    constructor(protected http: HttpClient) { super(http); }

    create(invoiceItem: InvoiceItem): Observable<InvoiceItem> {
        let copy: InvoiceItem = Object.assign({}, invoiceItem);
        return this.http.post<InvoiceItem>(this.resourceUrl, copy).map((res: InvoiceItem) => {
            return res;
        });
    }

    update(invoiceItem: InvoiceItem): Observable<InvoiceItem> {
        let copy: InvoiceItem = Object.assign({}, invoiceItem);
        return this.http.put<InvoiceItem>(this.resourceUrl, copy).map((res: InvoiceItem) => {
            return res;
        });
    }

    find(id: number): Observable<InvoiceItem> {
        return this.http.get<InvoiceItem>(`${this.resourceUrl}/${id}`).map((res: InvoiceItem) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<InvoiceItem[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<InvoiceItem[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<InvoiceItem[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<InvoiceItem[]>>(this.resourceSearchUrl, options)
            ;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice-item/invoice-item.service.ts